// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__29wV-","box":"WorkspacesBox_box__3l1V0","node":"WorkspacesBox_node__o5ZT7"};